var _jsxFileName = "/codebuild/output/src1346489397/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/auth/ResetPassword/index.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Button, LoadingModal, Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAccount, useApiError } from 'Hooks';
import { FormContainer, InputPassword, PasswordInputValidator } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { resetPass } from 'Services/auth';
import { Container } from './helpers/';
import { ResetFailure, ResetSuccess } from './states';
const mapStateToProps = ({
  config: {
    passwordRules
  },
  nav: {
    query: {
      email,
      token,
      product,
      version,
      country
    }
  }
}) => {
  return {
    email,
    token,
    product,
    version,
    country,
    passwordRules
  };
};
const initialValuesFormik = {
  newPassword: '',
  repeatNewPassword: ''
};
const connector = connect(mapStateToProps);
const ResetPassword = ({
  token,
  email,
  product,
  version,
  country,
  passwordRules
}) => {
  const [loading, setLoading] = useState(false);
  const [flowState, setFlowState] = useState('form');
  const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const {
    showPasswordValidationError
  } = useAccount();
  const validationSchema = Yup.object().shape({
    repeatNewPassword: Yup.string().required(i18n.t('ResetPassword.content.resetPasswordForm.formField.repeatNewPassword.errors.passwordMustMatch')).oneOf([Yup.ref('newPassword')], i18n.t('ResetPassword.content.resetPasswordForm.formField.repeatNewPassword.errors.passwordMustMatch'))
  });
  const {
    handleSubmit,
    handleBlur,
    setValues,
    handleChange,
    isValid,
    errors,
    touched,
    values,
    setTouched
  } = useFormik({
    initialValues: initialValuesFormik,
    onSubmit: onSubmitForm,
    validationSchema,
    validateOnBlur: true
  });
  const handleApiRequestError = useCallback(error => {
    switch (error.status) {
      case ApiStatus.BAD_REQUEST:
        {
          var _error$response, _error$response2;
          setValues(initialValuesFormik);
          setTouched({});
          const errors = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.errors;
          const code = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.code;
          if (code === ApiStatus.INVALID_DATA_CODE) {
            showPasswordValidationError(passwordRules, errors, country);
            return;
          }
          showApiErrorModal();
          break;
        }
      case ApiStatus.UNAUTHORIZED:
        {
          setFlowState('failure');
          break;
        }
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [showNetworkErrorModal, showApiErrorModal, setValues, setTouched, showPasswordValidationError, passwordRules, country]);
  function onSubmitForm() {
    setLoading(true);
    resetPass(values.newPassword, token, product, version).then(() => setFlowState('success')).catch(handleApiRequestError).finally(() => {
      setLoading(false);
    });
  }
  const isFormSubmittable = values.newPassword && values.repeatNewPassword && isValid && meetsPasswordRequirements;
  if (flowState === 'success') {
    return /*#__PURE__*/React.createElement(Container, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(ResetSuccess, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 9
      }
    }));
  }
  if (flowState === 'failure') {
    return /*#__PURE__*/React.createElement(Container, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(ResetFailure, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 9
      }
    }));
  }

  // for the email to show up please add `&email=someemail@email.com` to the url
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Container, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    gap: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 176,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$h2.strong",
    testID: "ResetPassword.title",
    nativeID: "ResetPassword.title",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 11
    }
  }, i18n.t('ResetPassword.title')), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center",
    testID: "ResetPassword.subtitle",
    nativeID: "ResetPassword.subtitle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 11
    }
  }, i18n.t('ResetPassword.subtitle')), /*#__PURE__*/React.createElement(Text, {
    style: {
      wordBreak: 'break-word'
    },
    textAlign: "center",
    testID: "ResetPassword.title-email",
    nativeID: "ResetPassword.title-email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 11
    }
  }, email)), /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(PasswordInputValidator, {
    placeholder: i18n.t('ResetPassword.content.resetPasswordForm.formField.newPassword.placeholder'),
    label: i18n.t('ResetPassword.content.resetPasswordForm.formField.newPassword.label'),
    onChangeText: handleChange('newPassword'),
    errors: errors,
    touched: touched,
    handleBlur: handleBlur('newPassword'),
    password: values.newPassword,
    onValidate: setMeetsPasswordRequirements,
    passwordRules: passwordRules,
    testID: "newPassword",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    label: i18n.t('ResetPassword.content.resetPasswordForm.formField.repeatNewPassword.label'),
    placeholder: i18n.t('ResetPassword.content.resetPasswordForm.formField.repeatNewPassword.placeholder'),
    testID: "repeatNewPassword",
    onBlur: handleBlur('repeatNewPassword'),
    onChangeText: handleChange('repeatNewPassword'),
    onSubmitEditing: () => isFormSubmittable ? handleSubmit() : {},
    defaultValue: values.repeatNewPassword,
    isInvalid: errors.repeatNewPassword && touched.repeatNewPassword ? true : false,
    errorMessage: errors.repeatNewPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Button, {
    testID: "ResetPassword.button",
    onPress: () => handleSubmit(),
    disabled: !isFormSubmittable,
    label: i18n.t('ResetPassword.title'),
    "aria-label": i18n.t('ResetPassword.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 233,
      columnNumber: 9
    }
  })));
};
export default connector(ResetPassword);